import React, { useEffect, useState } from 'react';
import VerificationPopup from '../modals/VerificationPopup';
import styles from '../../styles/newFeature.module.css';
import content from '../../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage, StackContainers, StackSkeleton } from '../qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from '../Industry/FAQ_mobile';
import FrequentQuestions from '../homePage/FrequentQuestions';
import MobilePDBanner from '../common/MobilePDBanner';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import TestimonialSection from '../common/TestimonialSection';
import MobileTestimonialSection from '../common/MobileTestimonialSection';
import ThreeStepForm from '../common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from '../common/OutletFeatures';
import { useRouter } from 'next/router';

const CloudKitchen = () => {
  const { commonMarqueTitle } = getTitleContent();
  const { testimonialHeadText } = content.testimonial;
  const [demoModal, setDemoModal] = useState(false);
  const [formHeading, setHeading] = useState("Book your free demo now!");
  const [mobileView, setmobileView] = useState(0);
  const [heroReadMore, setHeroReadMore] = useState(false);
  const router = useRouter()

  const setWindowDimensions = () => {
    window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
  };

  useEffect(() => {
    setWindowDimensions();
    window.addEventListener("resize", setWindowDimensions);
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  const features = [
    {
      id: 1,
      image: "/assets/outlet/cloudKitchen/pos.webp",
      tag: "Point Of Sale",
      icon: "/assets/groceries/kirana/POS.svg",
      title: "Fast Billing, Happy Customers",
      desc: "QueueBuster's POS system ensures that your cloud kitchen can process orders quickly and efficiently. With a user-friendly interface, it minimizes errors and keeps customers satisfied by reducing wait times. Integrated payment solutions further streamline the billing process, making sure every transaction is smooth and error-free.",
      tagColor: "#8AE4F6",
      bgColor: "#8ae4f626",
      stackColor1: "#D6F6FC",
      stackColor2: "#B0EFFC",
      stackColor3: "#8AE4F6",
      stackColor4: "#70D3E6",
      sHeight: "7rem",
      eHeight: "20rem",
      msHeight: "10rem",
      meHeight: "28rem",
      btnText: "Contact Sales",
      points: [
        <>
          Quickly process orders and payments with a user-friendly interface.
        </>,
        <>
          Minimize wait times and keep customers satisfied with fast billing.
        </>,
        <>
          Ensure error-free transactions with integrated payment solutions.
        </>,
      ],
    },
    
    {
      id: 2,
      image: "/assets/outlet/cloudKitchen/inventory.webp",
      tag: "Inventory Management",
      icon: "/assets/outlet/iceCreamOutlet/inventoryManagementIcon.svg",
      title: "Inventory & Raw Material Tracking",
      desc: "Inventory & Raw Material Tracking is crucial for cloud kitchens, and QueueBuster offers a solution that keeps you on top of it all. Track every ingredient with real-time updates, set up automatic alerts to avoid stockouts or overstocking, and manage raw materials efficiently to ensure consistent quality.",
      tagColor: "#FFBA00",
      bgColor: "#fff7e2",
      stackColor1: "#FEF8EB",
      stackColor2: "#FEEAC0",
      stackColor3: "#FFD579",
      stackColor4: "#FFC23E",
      sHeight: "10rem",
      eHeight: "26rem",
      msHeight: "15rem",
      meHeight: "41rem",
      btnText: "Contact Sales",
      points: [
        <>
          Track every ingredient with real-time inventory updates.
        </>,
        <>
          Set up automatic alerts to avoid stockouts and overstocking.
        </>,
        <>
          Ensure consistent quality by managing raw materials efficiently.
        </>,
      ],
    },
    // {
    //   id: 3,
    //   image: "/assets/outlet/cloudKitchen/management-software.webp",
    //   tag: "CRM & Loyalty Programs",
    //   icon: "/assets/outlet/iceCreamOutlet/vendorIcon.svg",
    //   title: "Management Software: Centralized Control at Your Fingertips",
    //   desc: "With QueueBuster’s Management Software, you can centralize your business operations into one powerful tool. Gain valuable insights into performance with comprehensive reporting and oversee multiple locations from a single dashboard. Whether you’re managing one kitchen or several, our software keeps you in control.",
    //   tagColor: "#EEC9FF",
    //   bgColor: "#fcf6ff",
    //   stackColor1: "#FCF7FF",
    //   stackColor2: "#F4E1FF",
    //   stackColor3: "#EEC9FF",
    //   stackColor4: "#E4ADFE",
    //   sHeight: "10rem",
    //   eHeight: "29rem",
    //   msHeight: "17rem",
    //   meHeight: "45rem",
    //   btnText: "Talk	to an expert",
    //   points: [
    //     <>
    //       Centralize your business operations with powerful management tools.
    //     </>,
    //     <>
    //       Gain insights into performance with comprehensive reporting.
    //     </>,
    //     <>
    //       Easily oversee multiple locations from a single dashboard.
    //     </>,
    //   ],
    // },
    {
      id: 4,
      image: "/assets/outlet/cloudKitchen/centeral-kitchen.webp",
      tag: "Central Kitchen Management",
      icon: "/assets/outlet/iceCreamOutlet/ckm.svg",
      title: "Centralized Coordination for All Outlets",
      desc: "QueueBuster Cloud Kitchen POS offers Central Kitchen Management that allows you to coordinate production across all your outlets from a central hub. Distribute prepared items efficiently, monitor ingredient usage, and reduce waste with precise tracking, ensuring consistent quality across all locations.",
      tagColor: "#4EEAC2",
      bgColor: "#e6fff9",
      stackColor1: "#C8F4E9",
      stackColor2: "#9EE9D6",
      stackColor3: "#4EEAC2",
      stackColor4: "#47DDB6",
      sHeight: "7rem",
      eHeight: "20rem",
      msHeight: "7rem",
      meHeight: "23rem",
      btnText: "Contact Sales",
      points: [
        <>
          Coordinate production across all your outlets from a central hub.
        </>,
        <>
          Efficiently distribute prepared items to various locations.
        </>,
        <>
          Monitor ingredient usage and reduce waste with precise tracking.
        </>,
      ],
    },
    {
      id: 5,
      image: "/assets/outlet/cloudKitchen/multiple-order.webp",
      tag: "Multiple Order Management",
      icon: "/assets/outlet/iceCreamOutlet/multiorder.svg",
      title: "Optimize Order Management for Quick Service",
      desc: "Our Multiple Order Management feature is designed to handle the high volume of orders that cloud kitchens often face. With clear and organized order queues, you can streamline the preparation process and ensure timely delivery with real-time order status updates.",
      tagColor: "#FFC3C3",
      bgColor: "#FFF3F3",
      stackColor1: "#FFF3F3",
      stackColor2: "#FFEBEB",
      stackColor3: "#FFDBDB",
      stackColor4: "#FFC3C3",
      sHeight: "7rem",
      eHeight: "20rem",
      msHeight: "7rem",
      meHeight: "23rem",
      btnText: "Contact Sales",
      points: [
        <>
          Handle high volumes of orders with ease and efficiency.
        </>,
        <>
          Streamline the preparation process with clear, organized order queues.
        </>,
        <>
          Ensure timely delivery with real-time order status updates.
        </>,
      ],
    },
    {
      id: 6,
      image: "/assets/outlet/cloudKitchen/multi-brand.webp",
      tag: "Multi Brand Management",
      icon: "/assets/outlet/gaming-parlor/multibrands.svg",
      title: "Manage Multiple Brands from a Single Platform",
      desc: "For cloud kitchens running multiple brands, QueueBuster provides Multi Brand Management that allows you to operate all your brands from one platform. Tailor settings for each brand while keeping your brand identities distinct. Easily switch between brands to ensure smoother, faster operations.",
      tagColor: "#77DFE6",
      bgColor: "#8ae4f626",
      stackColor1: "#D6F6FC",
      stackColor2: "#B0EFFC",
      stackColor3: "#8AE4F6",
      stackColor4: "#70D3E6",
      sHeight: "7rem",
      eHeight: "20rem",
      msHeight: "10rem",
      meHeight: "28rem",
      btnText: "Contact Sales",
      points: [
        <>
          Operate multiple brands from one platform with tailored settings.
        </>,
        <>
          Keep your brand identities distinct while managing them together.
        </>,
        <>
          Easily switch between brands for smoother, faster operations.
        </>,
      ],
    },
    // {
    //   id: 7,
    //   image: "/assets/outlet/cloudKitchen/inventory.webp",
    //   tag: "Inventory Management",
    //   icon: "/assets/outlet/gaming-parlor/yellow-report.svg",
    //   title: "Inventory & Raw Material Tracking",
    //   desc: "Inventory & Raw Material Tracking is crucial for cloud kitchens, and QueueBuster offers a solution that keeps you on top of it all. Track every ingredient with real-time updates, set up automatic alerts to avoid stockouts or overstocking, and manage raw materials efficiently to ensure consistent quality.",
    //   tagColor: "#F8D378",
    //   bgColor: "#fff7e2",
    //   stackColor1: "#FEF8EB",
    //   stackColor2: "#FEEAC0",
    //   stackColor3: "#FFD579",
    //   stackColor4: "#FFC23E",
    //   sHeight: "10rem",
    //   eHeight: "26rem",
    //   msHeight: "15rem",
    //   meHeight: "41rem",
    //   btnText: "Contact Sales",
    //   points: [
    //     <>
    //       Track every ingredient with real-time inventory updates.
    //     </>,
    //     <>
    //       Set up automatic alerts to avoid stockouts and overstocking.
    //     </>,
    //     <>
    //       Ensure consistent quality by managing raw materials efficiently.
    //     </>,
    //   ],
    // },
  ];

  const faqs = [
    {
      para: (
        <span style={{ width: "90%" }}>
          How does QueueBuster Cloud Kitchen POS improve the efficiency of order processing?
        </span>
      ),
      des: "QueueBuster Cloud Kitchen POS is designed in a user-friendly way that will enhance order processing efficiency, reducing manual input to minimize errors. In our system, one can quickly input orders, which increases transaction times and helps maintain a smooth flow in high-volume environments. The integrated payment solutions ensure smooth billing and minimize the wait time of customers to enhance customer experience. Realtime syncing with kitchen displays helps in precise order preparation and expedites the processing to deliver more quickly.",
      id: 1,
      activeIndex: 1,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          What are the key features of QueueBuster's Restaurant Software?
        </span>
      ),
      des: "QueueBuster's Restaurant Software is purposed for optimizing front-of-house and back-of-house operations. Advanced order management ensures that customer requests are dealt with promptly and effectively; real-time tracking in synchronizing staff activities is enabled, and it provides tools offering increased table turnover, and improved service speed. This comprehensive system further allows smooth communication between kitchen staff and servers to deliver orders with precision at peak hours. Moreover, reporting is staunch, enabling analysis of operational performance to determine points of improvement.",
      id: 2,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          How does QueueBuster's Management Software enable centralized control?
        </span>
      ),
      des: "QueueBuster's Management Software provides a strong central control system integrated with almost all facets of your cloud kitchen operations within one single dashboard. Using QueueBuster management software will help you manage multiple locations from one dashboard and leverage insightful knowledge in key performance metrics supported with detailed reports. This, in turn, will enable you to monitor key operational indicators such as sales trends, inventory levels, and employee performance with data-driven decisions. Full customization support of all reports and dashboards is available with the software to ensure you are focused on the metrics that truly matter to your business.",
      id: 3,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          What are the benefits of Central Kitchen Management in QueueBuster Cloud Kitchen POS?
        </span>
      ),
      des: "QueueBuster Cloud Kitchen POS enables users to manage the main kitchen, which can coordinate the production at all outlets with ease from its central hub. This module helps in the distribution of prepared items efficiently, ensuring that every location receives the required products without any delay. It also provides features to monitor ingredient usage, which helps in managing inventory levels and reducing wastage. You can centralize production management, maintain consistent quality across all locations, and smooth the entire workflow from preparation right through to delivery.",
      id: 4,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          How does MultipleOrder Management handle high volumes of orders?
        </span>
      ),
      des: "In QueueBuster, the MultipleOrder Management settings go through high volumes of orders without breaking a sweat. It sorts orders into prioritized, clearcut queues that help streamline the preparation process and ensure every order is prepared at the right time. Status updates on orders in real-time will help the chain maintain a tab on each order's progress. This will thereby enable coordination between kitchen staff and delivery teams. In fact, this allows for the smooth and efficient functioning of an order management system that at all times reduces the occurrence of bottlenecks, ensuring timely fulfillment of orders even on busy days.",
      id: 5,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          What is Multi Brand Management in QueueBuster Cloud Kitchen POS?
        </span>
      ),
      des: "QueueBuster has multi-brand management that allows the running of more than one brand on one console, hence managing disparate operations upward is easy. It facilitates settings for each brand regarding menus, pricing, and promotional offers while maintaining its identity in a specific direction. You can easily switch between brands on the same system, which makes it easy to keep up with the management and ensure that all unique requirements that come along with each brand are met. This capability is key to cloud kitchens with multiple brands, simplifying operations, and in essence, making everything more efficient.",
      id: 6,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          How does QueueBuster's Inventory & Raw Material Tracking make for efficient management?
        </span>
      ),
      des: "QueueBuster's Inventory & Raw Material Tracking includes a suite of tools that help in the efficient management of inventories and raw materials. Realtime updates on the level of ingredients will show that it keeps track of available stock to avoid situations such as stockouts or overstocking. Automatic notifications will let you know whenever the levels have reached the order threshold or reorder points you set, so you can take immediate action to reorder the supply of it. The system also provides features for tracking ingredient usage that help reduce waste and assure consistent product quality. All this efficient inventory management finally pays off in better cost control and operational efficiency.",
      id: 7,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Does QueueBuster Cloud Kitchen POS support integration with any existing hardware and software system?
        </span>
      ),
      des: "Yes, QueueBuster Cloud Kitchen POS seamlessly integrates with a wide array of existing hardware and software systems. Whether it is for multiple payment solutions, kitchen display systems, or inventory management tools, QueueBuster ensures that all elements talk to each other in harmony. It offers a plethora of integrations that will enable you to connect to the leading software platforms and also the most popular payment gateways for coherent and productive functioning. This flexibility ensures that you can leverage your existing investments while benefiting from the advanced features of QueueBuster.",
      id: 8,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          What kind of customer support does QueueBuster offer for its Cloud Kitchen POS?
        </span>
      ),
      des: "QueueBuster offers complete customer support to ensure that you derive optimum use of your Cloud Kitchen POS system. From installation and configuration to ongoing maintenance, our support team will be there to assist you at every step. Other channels of support include phone, email, and live chat for resolving any issue or question that may crop up. Supporting documentation, tutorials, and training will be provided to bring you and your staff up to speed on how to use the system. We want you to be satisfied, knowing that whenever a question or concern arises, it gets dealt with efficiently and effectively.",
      id: 9,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          How do I request a demo, or how do I get started with QueueBuster Cloud Kitchen POS?
        </span>
      ),
      des: "To request a demo or to get started with QueueBuster Cloud Kitchen POS, just reach out to our sales team from our website, or contact us directly via call. We offer customized demos to show you precisely how our POS system can be tailored to your needs. In this demo, we are going to go through the features and functionalities that make up the system, answer any of the questions that may pop into your head, and give you some details on how QueueBuster can help you improve your cloud kitchen processes. Our team will assist in the onboarding process to make everything smooth and get the POS up and running in your kitchen.",
      id: 10,
      activeIndex: 0,
    },
  ];

  return (
    <div>
        <div className={styles.verificationPopupOverride}>
          <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
        </div>
      {
        mobileView ?
          <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/outlet/cloudKitchen/mobile-hero-img.webp')" }}>
            <div>
              <h1>
                <span>POS Software for </span><span></span>
                <span>&nbsp; Cloud Kitchen </span>
              </h1>
              <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>Running a cloud kitchen demands precision, speed, and adaptability. QueueBuster Cloud Kitchen POS is designed to meet these exact needs, providing you with a robust system that handles everything from order processing to inventory management. Whether you're managing a single kitchen or a multi-kitchen operation, our POS solution simplifies your workflow, enhances productivity, and keeps your business thriving.</p>
              <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
              <div className={styles.btn_container}>
                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
              </div>
            </div>
          </div>
          :
          <div className={styles.sections}>
            <HeroSection
              style={{ font: "normal normal bold 5rem/5.5rem Inter", color: "#fff" }}
              backgroundImg="/assets/outlet/cloudKitchen/hero-img.webp"
              heading={<>POS Software for </>}
              staticHeading={<> Cloud Kitchen</>}
              description={"Running a cloud kitchen demands precision, speed, and adaptability. QueueBuster Cloud Kitchen POS is designed to meet these exact needs, providing you with a robust system that handles everything from order processing to inventory management. Whether you're managing a single kitchen or a multi-kitchen operation, our POS solution simplifies your workflow, enhances productivity, and keeps your business thriving."}
              solidBtnText={"Contact Sales"}
              textContainerStyle={{ width: "60%" }}
              setDemoModal={setDemoModal}
            />
          </div>
      }

      <div className={styles.marquee_section}>
        <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
        <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
      </div>

      <div className={styles.features_section}>
        <div className={styles.section_heading}><h3>Features of QueueBuster Cloud Kitchen POS</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
        <OutletFeatures features={features} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
      </div>

      <div className={styles.three_step_form}>
        <ThreeStepForm mobileView={mobileView} />
      </div>

      <div className={styles.testimonial_section}>
        <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
        {
          mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
            <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
        }
      </div>

      <div style={{ marginTop: "6rem" }}>
        {
          mobileView ?
            <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"FAQ for Cloud Kitchen POS System"} />
            :
            <FrequentQuestions FaqTableData={faqs} heading={"FAQ for Cloud Kitchen POS System"} />
        }
      </div>

      <div className={styles.demo_banner_section}>
        {
          mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
        }
      </div>
    </div>
  )
}

export default CloudKitchen